import {
  html,
  attr,
  TNode,
  Signal,
  ForEach,
  NotEmpty,
  Value,
} from '@tempots/dom'

export interface DataTableColumn<T> {
  key: keyof T
  header: TNode
  render?: (item: Signal<T>) => TNode
  className?: Value<string>
}

export interface DataTableOptions<T> {
  columns: DataTableColumn<T>[]
  data: Signal<T[]>
  renderMobileCard: (item: Signal<T>) => TNode
  emptyMessage?: TNode
}

export function DataTable<T extends { id: string }>({
  columns,
  data,
  renderMobileCard,
  emptyMessage = 'No items found',
}: DataTableOptions<T>) {
  return NotEmpty(
    data,
    (data) =>
      // Desktop table
      html.div(
        attr.class('hidden lg:block overflow-x-auto'),
        html.table(
          attr.class('min-w-full divide-y divide-gray-200'),
          html.thead(
            attr.class('bg-gray-50'),
            html.tr(
              ...columns.map((col) =>
                html.th(
                  attr.class(
                    'px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'
                  ),
                  col.header
                )
              )
            )
          ),
          html.tbody(
            attr.class('bg-white divide-y divide-gray-200'),
            ForEach(data, (item) =>
              html.tr(
                attr.class('hover:bg-gray-50'),
                ...columns.map((col) =>
                  html.td(
                    attr.class(`px-6 py-4 whitespace-nowrap`),
                    attr.class(col.className),
                    col.render
                      ? col.render(item)
                      : item.map((i) => String(i[col.key] ?? ''))
                  )
                )
              )
            )
          )
        ),
        // Mobile cards
        html.div(
          attr.class('lg:hidden space-y-4'),
          ForEach(data, renderMobileCard)
        )
      ),
    () => html.div(attr.class('text-center py-12 text-gray-500'), emptyMessage)
  )
}
